var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdMenuModule, MdListModule } from '@angular/material';
import { TdMenuComponent } from './menu.component';
var TD_MENU = [
    TdMenuComponent,
];
export { TdMenuComponent } from './menu.component';
var CovalentMenuModule = CovalentMenuModule_1 = (function () {
    function CovalentMenuModule() {
    }
    CovalentMenuModule.forRoot = function () {
        return {
            ngModule: CovalentMenuModule_1,
            providers: [],
        };
    };
    return CovalentMenuModule;
}());
CovalentMenuModule = CovalentMenuModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            MdMenuModule.forRoot(),
            MdListModule.forRoot(),
        ],
        declarations: [
            TD_MENU,
        ],
        exports: [
            TD_MENU,
        ],
    })
], CovalentMenuModule);
export { CovalentMenuModule };
var CovalentMenuModule_1;
//# sourceMappingURL=menu.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@covalent/core/menu/menu.module.js
// module id = 510
// module chunks = 3